theme.ScrollingStory = (function () {
  function ScrollingStory(container) {
    this.container = container;
    this.init();
  }

  ScrollingStory.prototype.init = function () {
    const containerTrigger = this.container;
    const scrollWrapper = this.container.querySelector(
      '.scrolling-story__scroll-content-wrapper',
    );
    const scrollContent = this.container.querySelector(
      '.scrolling-story__scroll-content',
    );
    const imageContainer = this.container.querySelector(
      '.scrolling-story__image-container',
    );
    const images = this.container.querySelectorAll(
      '.scrolling-story__image-wrapper',
    );
    if (
      !containerTrigger ||
      !scrollWrapper ||
      !scrollContent ||
      !imageContainer ||
      !images.length
    )
      return;

    // window.addEventListener('resize', gsap.matchMediaRefresh);

    const mm = gsap.matchMedia();

    mm.add(
      {
        isDesktop: '(min-width: 1024px)',
        isTablet: '(min-width: 768px)',
        isMobile: '(max-width: 767px)',
      },
      (context) => {
        const { isDesktop, isTablet, isMobile } = context.conditions;
        gsap.set([scrollContent, ...images], { clearProps: 'all' });

        scrollWrapper.style.overflow = 'visible';
        const totalImages = images.length;
        const contentHeight = scrollContent.scrollHeight;
        const imageContainerHeight = imageContainer.offsetHeight;
        const viewportHeight = window.innerHeight;
        let scrollDistance = contentHeight - viewportHeight;
        if ((isMobile || isTablet) && !isDesktop) {
          const topPadding = imageContainerHeight + 20;
          scrollContent.style.paddingTop = `${topPadding}px`;
          scrollDistance =
            contentHeight - (viewportHeight - imageContainerHeight);
        }
        const imageIncr = scrollDistance / totalImages;
        const fadeDuration = imageIncr * 0.5;
        // ScrollTrigger.normalizeScroll(true);
        if (isDesktop || isTablet || isMobile) {
          gsap.set(scrollContent, { y: 0 });
          images.forEach((img, i) => {
            gsap.set(img, { autoAlpha: i === 0 ? 1 : 0, ease: 'power1.inOut' });
          });
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: containerTrigger,
              start: 'top top',
              end: `+=${scrollDistance}`,
              scrub: true,
              pin: true,
            },
          });
          tl.to(
            scrollContent,
            {
              y: -scrollDistance,
              ease: 'none',
              duration: scrollDistance,
            },
            0,
          );
          images.forEach((img, i) => {
            if (i > 0) {
              tl.to(
                img,
                {
                  autoAlpha: 1,
                  duration: fadeDuration,
                  ease: 'power1.inOut',
                },
                i * imageIncr,
              );
            }
          });
        }
      },
    );
  };

  return ScrollingStory;
})();
